module.exports = "<p>\n  escala-novedades works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/module/libranza/escala-novedades/escala-novedades.component.html
// module id = 743
// module chunks = 0